import moment from 'moment'

// eslint-disable-next-line import/prefer-default-export
export const convertToData = ({
  id,
  title,
  created,
  modified,
  files,
  submitted,
}) => ({
  id,
  title: title || 'Untitled',
  created: moment(String(created)).format('MM/DD/YYYY hh:mm'),
  modified: moment(String(modified)).format('MM/DD/YYYY hh:mm'),
  files,
  submitted,
})
